import { isShowDiwaliDiya } from '../special-params';

let underlyingFoldSizeRaw = 1245;
let underlyingFoldLargeSizeRaw = 1525;

if (isShowDiwaliDiya) {
  underlyingFoldSizeRaw = 1300;
  underlyingFoldLargeSizeRaw = 1575;
}

export const underlyingFoldSize = underlyingFoldSizeRaw;
export const underlyingFoldLargeSize = underlyingFoldLargeSizeRaw;
